import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import { createIcons, ChevronLeft, ChevronRight } from 'lucide';

export function initCollectionsSwiper() {
  const swiperElements = document.querySelectorAll('.collections-swiper');

  swiperElements.forEach((swiperEl) => {
    const enableAutoplay = swiperEl.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(swiperEl.dataset.autoplayDelay) || 5000;
    const enablePagination = swiperEl.dataset.pagination === 'true';
    const enableLoop = swiperEl.dataset.loop === 'true';

    const modules = [];
    if (enablePagination) modules.push(Pagination);
    if (enableAutoplay) modules.push(Autoplay);

    const swiper = new Swiper(swiperEl, {
      modules,
      slidesPerView: 3.7,
      spaceBetween: 12,
      loop: enableLoop,
      centeredSlides: false,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      pagination: enablePagination ? {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 16,
        },
        1440: {
          slidesPerView: 10.7,
          spaceBetween: 10,
        },
      },
      speed: 400,
      effect: 'slide',
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      on: {
        init: function() {
          // Initialize Lucide icons after Swiper is ready
          setTimeout(() => {
            createIcons({
              icons: {
                ChevronLeft,
                ChevronRight,
              },
            });
          }, 0);
        },
      },
    });

    // Custom Navigation - Get buttons outside .swiper container
    const sliderContainer = swiperEl.closest('.slider-container');
    const prevBtn = sliderContainer.querySelector('.custom-arrow--prev');
    const nextBtn = sliderContainer.querySelector('.custom-arrow--next');

    if (prevBtn && nextBtn) {
      // Manual navigation control
      prevBtn.addEventListener('click', () => {
        swiper.slidePrev();
      });

      nextBtn.addEventListener('click', () => {
        swiper.slideNext();
      });

      // Update disabled states
      function updateArrows() {
        prevBtn.disabled = swiper.isBeginning;
        nextBtn.disabled = swiper.isEnd;
      }

      // Listen to slide changes
      swiper.on('slideChange', updateArrows);
      swiper.on('init', updateArrows);

      // Initial state
      updateArrows();
    }
  });
}

export function initRecommendedSwiper() {
  const swiperElements = document.querySelectorAll('.recommended-swiper');

  swiperElements.forEach((swiperEl) => {
    const enableAutoplay = swiperEl.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(swiperEl.dataset.autoplayDelay) || 5000;
    const enableLoop = swiperEl.dataset.loop === 'true';

    const modules = [];
    if (enableAutoplay) modules.push(Autoplay);

    const swiper = new Swiper(swiperEl, {
      modules,
      slidesPerView: 2.5,
      spaceBetween: 12,
      loop: enableLoop,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      breakpoints: {
        480: {
          slidesPerView: 2.5,
          spaceBetween: 12,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 20,
        },
      },
      speed: 400,
      effect: 'slide',
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      on: {
        init: function() {
          // Initialize Lucide icons after Swiper is ready
          setTimeout(() => {
            createIcons({
              icons: {
                ChevronLeft,
                ChevronRight,
              },
            });
          }, 0);
        },
      },
    });

    // Custom Navigation - Get buttons outside .swiper container
    const sliderContainer = swiperEl.closest('.recommended-slider-container');
    const prevBtn = sliderContainer.querySelector('.recommended-arrow--prev');
    const nextBtn = sliderContainer.querySelector('.recommended-arrow--next');

    if (prevBtn && nextBtn) {
      // Manual navigation control
      prevBtn.addEventListener('click', () => {
        swiper.slidePrev();
      });

      nextBtn.addEventListener('click', () => {
        swiper.slideNext();
      });

      // Update disabled states
      function updateArrows() {
        prevBtn.disabled = swiper.isBeginning;
        nextBtn.disabled = swiper.isEnd;
      }

      // Listen to slide changes
      swiper.on('slideChange', updateArrows);
      swiper.on('init', updateArrows);

      // Initial state
      updateArrows();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initCollectionsSwiper();
    initRecommendedSwiper();
  });
} else {
  initCollectionsSwiper();
  initRecommendedSwiper();
}
